
import EditPoint from "../plot/EditPoint"
import { cartesian2lonlat } from "./utils/geojson"
import ConstantDraw from "../constants/ConstantDraw"
class EditPointSpace extends EditPoint {

    constructor(options) {
        super(options);
    }


    mouseMove(evt) {
        super.mouseMove(evt);
        if (this.pick) {
            var cartesian = this.pick.position.getValue();
            //this.pick.position.setValue(cartesian);
            var lonlat = cartesian2lonlat(cartesian);
            var lable = ConstantDraw.Style_Label;
            lable.text = `经度:${lonlat[0]}\n纬度:${lonlat[1]}\n高程:${lonlat[2]}`
            this.pick.label = lable;

            // this.getSampleHeight(cartesian);
        }
    }
}

export default EditPointSpace